import { render, staticRenderFns } from "./ToplistsPage.vue?vue&type=template&id=7c361d93&"
import script from "./ToplistsPage.vue?vue&type=script&lang=js&"
export * from "./ToplistsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports